<template>
  <div
    :class="
      isPendingDocumentSelected ? 'pendingDocumentCardSelected' : 'pendingDocumentCard'
    "
    class="overflow-hidden border-black"
    @click="selectCard(pendingDocument)"
    data-vs-button="select-card"
  >
    <div class="boxView flex" v-in-viewport.once>
      <div class="leftContainer border-r w-16 hidden xl:block">
        <div class="mx-auto w-5/12">
          <zt-check-box
            data-vs-checkbox="selected"
            v-model="checkSelectCard"
            :value="true"
            :key="keyCheckbox"
            @click.stop="pushCardToMassiveArray(pendingDocument)"
            fill
          />
        </div>
      </div>
      <div class="w-full h-full">
        <div class="flex items-center h-16 my-1 mx-3">
          <div class="w-1/2 flex items-center">
            <div class="imgContainer">
              <zt-avatar
                class="font-normal"
                :text="
                  pendingDocument.hasOwnProperty('errorOnProfilePick')
                    ? `${pendingDocument.nombre_usuario.split(' ')[0]}
              ${pendingDocument.apellido.split(' ')[0]}`
                    : ''
                "
                :src="
                  pendingDocument.hasOwnProperty('profilePic')
                    ? pendingDocument.profilePic
                    : null
                "
                size="35px"
                color="secondary-100"
              />
            </div>
            <div class="infoProfileContainer cursor-pointer flex flex-col w-custom-1">
              <zt-tooltip
                class="inline-block"
                :text="nombreApellidoUsuario"
                position="top"
              >
                <div
                  class="infoProfileName block text-base font-medium whitespace-no-wrap"
                >
                  <div class="truncate">{{ nombreApellidoUsuario }}</div>
                </div>
              </zt-tooltip>
            </div>
          </div>
          <div class="flex items-center" v-if="pendingDocument.id_type_flows === '1'">
            <zt-tooltip class="inline-block" :text="typeOfPendingDocument" position="top">
              <div class="documentType text-base capitalize truncate w-56">
                {{ typeOfPendingDocument }}
              </div>
            </zt-tooltip>
          </div>
        </div>
        <div class="sectorDateCuilContainer h-10 flex justify-between flex-row px-3 pb-2">
          <div class="sectorDateCuilBox w-full flex justify-between items-center">
            <div class="sectorLocation w-1/2" v-if="pendingDocument.id_type_flows === '1'">
              <zt-tooltip
                class="inline-block w-full"
                :text="userSectorLocation"
                position="top"
              >
                <div
                  class="infoProfileText text-zt-neutral-400 text-sm overflow-hidden whitespace-no-wrap overflow-hidden capitalize w-custom-2"
                >
                  <div class="truncate">{{ userSectorLocation }}</div>
                </div>
              </zt-tooltip>
            </div>
            <div class="sectorLocation w-1/2" v-else>
              <p class="documentTypeText text-sm uppercase px-2 rounded">
                {{ pendingDocument.nombre_tipo_documento }}
              </p>
            </div>

            <div class="halfBoxdateCuil w-1/2 flex justify-between items-center">
              <div class="licencias flex items-center">
                <zt-icon name="calendar-num text-zt-neutral-400 text-base pb-1 px-0" />
                <div class="text-sm mx-2 capitalize">
                  {{
                    pendingDocument.fecha_creacion !== null
                      ? fechaCreacionDocument
                      : $t(
                          "message.uploadImageComponent.body.noContentEmployeeInfo.noDate"
                        )
                  }}
                </div>
              </div>
              <div
                class="infoProfileText text-zt-neutral-400 text-sm overflow-hidden whitespace-no-wrap overflow-hidden capitalize mr-2"
              >
                {{
                  pendingDocument.cuil !== null
                    ? pendingDocument.cuil
                    : $t("message.uploadImageComponent.body.noContentEmployeeInfo.noCuil")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";

export default {
  props: {
    pendingDocument: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    selectedDocument: {
      type: Object,
      default: false,
    },
  },
  data() {
    return {
      checkSelectCard: false,
      keyCheckbox: 0,
    };
  },
  watch: {
    isInMassiveArray() {
      if (this.isInMassiveArray) {
        this.checkSelectCard = true;
        this.keyCheckbox++;
      } else if (!this.isInMassiveArray) {
        this.checkSelectCard = false;
        this.keyCheckbox++;
      }
    },
  },
  methods: {
    selectCard(document) {
      this.$emit("selectCard", document);
    },
    pushCardToMassiveArray(document) {
      this.$emit("pushCardToMassiveArray", document);
    },
  },
  computed: {
    isInMassiveArray() {
      return this.pendingDocument.selectedCard;
    },
    nombreApellidoUsuario() {
      return (
        (this.pendingDocument.nombre_usuario
          ? this.pendingDocument.nombre_usuario
              .toLowerCase()
              .replace(/^\w|\s./g, function (a) {
                return a.toUpperCase();
              })
          : "") +
        " " +
        (this.pendingDocument.apellido
          ? this.pendingDocument.apellido.toLowerCase().replace(/^\w|\s./g, function (a) {
              return a.toUpperCase();
            })
          : "")
      );
    },
    typeOfPendingDocument() {
      return this.pendingDocument.nombre_tipo_documento !== null
        ? this.pendingDocument.nombre_tipo_documento
        : this.$t(
            "message.uploadImageComponent.body.noContentEmployeeInfo.noArchiveName"
          );
    },
    userSectorLocation() {
      return (
        (this.pendingDocument.sector !== null
          ? this.pendingDocument.sector
          : this.$t("message.uploadImageComponent.body.noContentEmployeeInfo.noSector")) +
        " / " +
        (this.pendingDocument.locacion !== null
          ? this.pendingDocument.locacion
          : this.$t("message.uploadImageComponent.body.noContentEmployeeInfo.noLocacion"))
      );
    },
    fechaCreacionDocument() {
      return moment(
        this.pendingDocument.fecha_creacion.split(" ")[0],
        "DD/MM/YYYY"
      ).format("DD MMM YYYY");
    },
    isPendingDocumentSelected() {
      return _.isEqual(this.pendingDocument.id_carga, this.selectedDocument.id_carga);
    },
  },
  created() {
    if (this.isInMassiveArray) {
      this.checkSelectCard = true;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./public/assets/scss/_config.scss";

.pendingDocumentCard {
  background: #ffffff;
  border-left: solid 1px #e7e7e7;
  border-right: solid 1px #e7e7e7;
  border-bottom: solid 1px #e7e7e7;
}

.pendingDocumentCardSelected {
  background: #e1f5fe;
  border-left: solid 1px #e7e7e7;
  border-right: solid 1px #e7e7e7;
  border-bottom: solid 1px #e7e7e7;
}

.boxView {
  .leftContainer {
    padding-top: 5px;
  }
}

.infoProfileContainer {
  padding-left: 0.5em;
}

.infoProfileName {
  color: #707070;
  text-overflow: ellipsis;
}

.infoProfileText {
  text-overflow: ellipsis;
}

.documentType {
  color: #707070;
  text-overflow: ellipsis;
}

::v-deep .zt-avatar span {
  font-weight: 500;
  font-size: 17.5px;
}

.w-custom-1 {
  width: calc(100% - 41.5px - 0.5rem);
}
.w-custom-2 {
  width: calc(100% - 0.5rem);
}

.documentTypeText {
  border: 1px solid #03a9f4;
  background-color: #e1f5fe;
  width: fit-content;
  padding: 2px;
  color: #03a9f4;
}
</style>
